"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const httpRequest = ({ method, url, params, data, axios }) => axios.request({
    method,
    url,
    params,
    data
});
exports.default = httpRequest;
